import React, {useEffect, useState} from "react";
import DataTable from "../../../components/data-table";
import Breadcrumbs from "../../../components/breadcrumbs";
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import {
    createLink,
    CREATE_LINK,
    clear_employee,
    searchEmployees,
    get_report_employee,
    SEND_EMAIL_SETTING,
    GET_REPORT_EMPLOYEE,
    getAllEmployees,
    get_report_bonus,
    GET_REPORT_BONUS
} from '../../../redux/employees';
import {TYPE_EMPLOYEE} from '../../../config/index'
import {ToastContainer, toast} from 'react-toastify';
import Button from "../../../components/button";
import LoadingSpinner from "../../../components/loading-spinner";
import Modal from "../../../components/modal";
// import Input from "../../../components/input";
import Select from "react-select";
import {getAllJobs} from "../../../redux/jobs";
import SelectInput from "../../../components/select";

const Employees = (props) => {
    let dispatch = useDispatch();
    let history = useHistory();
    const employees = useSelector(
        (state) => state.employees_module._get_all_employees
    );
    const _create_link = useSelector(
        (state) => state.employees_module._create_link
    );
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const _jobs = useSelector((state) => state.jobs_module._get_all_jobs);

    const [data, setData] = useState([]);

    useEffect(() => {
        dispatch(getAllEmployees(token));
    }, [token, dispatch]);

    useEffect(() => {
        if (employees && employees.data && employees.data.datos) {
            // eslint-disable-next-line
            let empleados = employees.data.datos.filter((item) => {
                if (item.activo) {
                    return item;
                }
            })
            setData(empleados);
        }
    }, [employees]);

    useEffect(() => {
        if (_create_link.status === 200) {
            toast.success("Se envió el correo de confirmación al empleado");
            dispatch(clear_employee(CREATE_LINK));
        } else if (_create_link.status !== 0) {
            toast.error(_create_link.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            dispatch(clear_employee(CREATE_LINK));
        }
    }, [_create_link, dispatch]);

    const [permisos, setPermisos] = useState([]);
    const [actions, setActions] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [modalBonificacion, setModalBonificacion] = useState(false);
    // const [fechaInicio, setFechaInicio] = useState('');
    // const [fechaFin, setFechaFin] = useState('');
    const [year, setYear] = useState(0);
    const [month, setMonth] = useState(0);

    const [optionsJob, setOptionsJob] = useState([]);
    const [job_select, setJobSelect] = useState([]);

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 3 }, (_, i) => currentYear - 1 + i);
    const months = [
        {id: 1, value: "Enero"},
        {id: 2, value: "Febrero"},
        {id: 3, value: "Marzo"},
        {id: 4, value: "Abril"},
        {id: 5, value: "Mayo"},
        {id: 6, value: "Junio"},
        {id: 7, value: "Julio"},
        {id: 8, value: "Agosto"},
        {id: 9, value: "Septiembre"},
        {id: 10, value: "Octubre"},
        {id: 11, value: "Noviembre"},
        {id: 12, value: "Diciembre"},
    ];

    useEffect(() => {
        if (_jobs && _jobs.data && _jobs.data.datos) {
            let options = [];
            // eslint-disable-next-line
            _jobs.data.datos.map((item) => {
                if (item.bono_establecimiento) {
                    options.push({
                            value: item.id,
                            label: item.nombre,
                    });
                }
            });
            setOptionsJob(options);
        }
    }, [_jobs]);

    useEffect(() => {
        if (props) {
            const array = Object.values(props);
            setPermisos(array);
        }
    }, [props]);


    useEffect(() => {
        let act = []
        if (permisos) {
            if (permisos.filter(x => x.codigo === 'update_employing_company').length > 0 || permisos.filter(x => x.codigo === 'change_employees').length > 0) {
                act.push({
                    name: "edit",
                    label: "Editar",
                    icon: "bx bx-edit",
                    color: "primary",
                    onClick: (item) => {
                        history.push(`/empleados/editar/${item.id}`);
                    },
                })
            }
            if (permisos.filter(x => x.codigo === 'change_employees').length > 0) {
                act.push({
                    name: "send-email",
                    label: "Enviar correo cargar foto",
                    icon: "bx bx-send",
                    color: "warning",
                    onClick: (item) => {
                        sendEmail(TYPE_EMPLOYEE, item.id);
                    }
                });
            }
        }
        setActions(act);
        // eslint-disable-next-line
    }, [permisos, history]);


    const sendEmail = (type = TYPE_EMPLOYEE, id) => {
        dispatch(createLink(token, {
            tipo: type,
            id_empleado: id
        }))
    }

    const _send_email_setting = useSelector((store) => store.employees_module._send_email_setting);

    useEffect(() => {
        if (_send_email_setting.status === 200) {
            toast.success("Se envió el correo de empleado nuevo");
            dispatch(clear_employee(SEND_EMAIL_SETTING));
        } else if (_send_email_setting.status !== 0) {
            toast.error(_send_email_setting.message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
            dispatch(clear_employee(SEND_EMAIL_SETTING));
        }
    }, [_send_email_setting, dispatch]);

    // const send_email_setting = (id) => {
    //     dispatch(sendEmailSetting(token, id, {}));
    // }

    const [active, setActive] = useState('1');

    const handleChange = async (e) => {
        const params = '?buscar=' + e.target.value.toString()
        const response = await searchEmployees(token, params)
        setData(response.data.datos)
        setActive(e.target.value.toString())
    };

    const _get_report_employee = useSelector((store) => store.employees_module._get_report_employee);

    // const [report, setReport] = useState(false);

    useEffect(() => {
        if (_get_report_employee.status === 200) {
            toast.success(_get_report_employee.data.mensaje);
            dispatch(clear_employee(GET_REPORT_EMPLOYEE));
            setIsLoading(false);
        } else if (_get_report_employee.status !== 0) {
            toast.error(_get_report_employee.message);
            dispatch(clear_employee(GET_REPORT_EMPLOYEE));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_get_report_employee]);


    const handleGenerateReport = () => {
        setIsLoading(true);
        dispatch(get_report_employee({'activo': active}, token))
    }

    const _get_report_bonus = useSelector((store) => store.employees_module._get_report_bonus);

    useEffect(() => {
        if (_get_report_bonus.status === 200) {
            toast.success(_get_report_bonus.data.mensaje);
            dispatch(clear_employee(GET_REPORT_BONUS));
            setModalBonificacion(false);
            setIsLoading(false);
        } else if (_get_report_bonus.status !== 0) {
            toast.error(_get_report_bonus.message);
            dispatch(clear_employee(GET_REPORT_BONUS));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [_get_report_bonus]);

    const handleSubmitBonificacones = (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (month === 0) {
            toast.error("Debe seleccionar el mes", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        if (year === 0) {
            toast.error("Debe seleccionar el año", {position: toast.POSITION.TOP_RIGHT});
            setIsLoading(false);
            return;
        }
        dispatch(get_report_bonus({
            mes: month,
            anio: year,
            cargos: job_select
        }, token));
    }

    const handleChangeSelect = (e) => {
            setJobSelect(e);
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>
            <ToastContainer/>
            {isLoading && <LoadingSpinner/>}

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-1">
                        <Breadcrumbs
                            title="Empleados"
                            items={[{label: "Empleados", link: "/empleados"}]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="card">
                        <div className="card-content">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-8 col-12 mb-1">
                                        { permisos && permisos.filter(x => x.codigo === 'update_employing_company').length > 0 &&
                                                <>
                                                    <Link to="/empleados/crear" className="btn btn-success">
                                                        Crear
                                                    </Link>
                                                    <Link to="/empleados/importar"
                                                          className="ml-2 mr-1 btn btn-outline-primary">
                                                        Importar
                                                    </Link>
                                                </>
                                        }
                                        { permisos && permisos.filter(x => x.codigo === 'generate_report_employee').length > 0 &&
                                            <Button
                                                text={<h3><i className="text-white bx bx-export"/></h3>}
                                                theme="success"
                                                type="button"
                                                classes="btn-lg round"
                                                onClick={() => {
                                                    handleGenerateReport();
                                                }}
                                                disabled={isLoading}
                                            />
                                        }
                                        { permisos && permisos.filter(x => x.codigo === 'generate_report_bonus').length > 0 &&
                                            <Button
                                                text="Reporte de bonificaciones"
                                                theme="success"
                                                type="button"
                                                classes="btn-lg round ml-2"
                                                onClick={() => {
                                                    setMonth(0);
                                                    setYear(0);
                                                    document.getElementById("mes").selectedIndex = 0;
                                                    document.getElementById("anio").selectedIndex = 0;
                                                    setJobSelect([]);
                                                    dispatch(getAllJobs(token));
                                                    setModalBonificacion(true);
                                                }}
                                                disabled={isLoading}
                                            />
                                        }
                                        {/* {!report ? <Button text={<h3><i className="text-white bx bx-export"/></h3>
                                        } theme="success" type="button"
                                                           classes="btn-lg round ml-2"
                                                           onClick={() => handleGenerateReport()}
                                        /> : <div className="spinner-border text-success ml-2"
                                                  role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>} */}
                                    </div>
                                    <div className="col-md-4 col-12">
                                        <div className="form-group">
                                            <label>Filtrar</label>
                                            <select onChange={handleChange} className="form-control">
                                                <option value="1" selected>Activos</option>
                                                <option value="0">Inactivos</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <DataTable
                                        dataTable={data}
                                        columns={[
                                            {
                                                name: "foto",
                                                label: "Imagen",
                                                type: "avatar",
                                            },
                                            {
                                                name: "ruc",
                                                label: "Cédula",
                                                type: "text",
                                            },
                                            {
                                                name: "nombres",
                                                label: "Nombre",
                                                type: "text",
                                            },
                                            {
                                                name: "apellidos",
                                                label: "Apellidos",
                                                type: "text",
                                            },
                                            {
                                                name: "cargo",
                                                label: "Cargo",
                                                type: "text",
                                            },
                                            {
                                                name: "empresa",
                                                label: "Empresa",
                                                type: "text",
                                            },
                                            {
                                                name: "contribuyente_activo",
                                                label: "Contribuyente activo",
                                                type: "text",
                                            },
                                            {
                                                name: "establecimiento",
                                                label: "Establecimiento",
                                                type: "text",
                                            },
                                        ]}
                                        actions={actions}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className="modal-main" show={modalBonificacion}>
                {isLoading && <LoadingSpinner/>}
                <div className="modal-content">
                    <div className="modal-header">
                        <h5>Reportes de bonificaciones</h5>
                    </div>
                    <div className="modal-body p-2">
                        <form onSubmit={handleSubmitBonificacones}>
                            <div className="form-group">
                                <label>Mes</label>
                                <SelectInput
                                    id="mes"
                                    label="mes"
                                    name="mes"
                                    onChange={(e) => setMonth(parseInt(e.target.value))}
                                    options={months ? months.map((item) => ({
                                        name: item.value,
                                        id: item.id,
                                    })) : []}
                                />
                            </div>
                            <div className="form-group">
                                <label>Año</label>
                                <SelectInput
                                    id="anio"
                                    label="año"
                                    name="anio"
                                    onChange={(e) => setYear(parseInt(e.target.value))}
                                    options={years ? years.map((item) => ({
                                        name: item,
                                        id: item,
                                    })) : []}
                                />
                            </div>
                            {/*<div className="form-group">*/}
                            {/*    <Input*/}
                            {/*        name="fechaInicio"*/}
                            {/*        type="date"*/}
                            {/*        label="Fecha inicial"*/}
                            {/*        onChange={(e) => setFechaInicio(e.target.value)}*/}
                            {/*        value={fechaInicio}*/}
                            {/*    />*/}
                            {/*</div>*/}
                            {/*<div className="form-group">*/}
                            {/*    <Input*/}
                            {/*        name="fechaFin"*/}
                            {/*        type="date"*/}
                            {/*        label="Fecha final"*/}
                            {/*        onChange={(e) => setFechaFin(e.target.value)}*/}
                            {/*        value={fechaFin}*/}
                            {/*    />*/}
                            {/*</div>*/}
                            <div className="form-group">
                                <label>Cargos</label>
                                <Select
                                    options={optionsJob}
                                    isMulti={true}
                                    onChange={handleChangeSelect}
                                    value={job_select}
                                />
                            </div>
                            <div className="text-center">
                                <button type="button" className="btn btn-outline-dark" onClick={() => {
                                    setModalBonificacion(false);
                                }}> Cancelar
                                </button>
                                <Button type="submit" text="Generar reporte" theme="btn btn-success" classes="m-1"
                                        disabled={isLoading}/>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default Employees;
